import React from 'react';
import { renderDate } from '../../../../../../helpers';
import AiFillCalendar from '@meronex/icons/ai/AiFillCalendar';

function DealValidity({ date, removeTopMargin }) {
    return (
        <div
            className={`flex ${
                removeTopMargin ? ' mt-4' : 'mt-5 lg:mt-6  '
            } items-center`}
        >
            <AiFillCalendar />
            <p
                className={`ml-2 font-medium capitalize text-sm  tracking-wide `}
            >
                Valid till:{' '}
                <span className="text-primary font-medium">
                    {renderDate(date, false)}
                </span>
            </p>
        </div>
    );
}

export default DealValidity;
